import api from '../api/stopsApi';
import type { RequestParameters } from '../types/apiTypes';
import type { RidershipStopAreaLocation } from '../types/ridershipTypes';

function toNumber(n: any): number | undefined {
    if (typeof n === 'number') return n;
    const v = Number(n);
    return Number.isFinite(v) ? v : undefined;
}

export async function getStopsInAreaForMap(
    agencyId: string,
    centerLat: number,
    centerLon: number,
    radiusMiles: number,
    parameters?: RequestParameters,
): Promise<RidershipStopAreaLocation[]> {
    const result = await api.getStopsInArea(agencyId, centerLat, centerLon, radiusMiles, parameters);
    const rows = result.data || [];
    return rows
        .map((r: any) => ({
            stopId: String(r.StopId ?? r.stopId ?? r.Id ?? r.id ?? r.StopCode ?? r.stopCode ?? ''),
            stopName: String(r.Name ?? r.stopName ?? r.StopName ?? r.stopName ?? ''),
            stopCode: String(r.stopCode ?? r.StopCode ?? ''),
            latitude: toNumber(r.Lat ?? r.lat ?? r.Latitude ?? r.latitude) as any,
            longitude: toNumber(r.Lon ?? r.lon ?? r.Longitude ?? r.longitude) as any,
            distanceFromCenter: toNumber(r.DistanceFromCenter ?? r.distanceFromCenter),
        }))
        .filter(stop =>
            stop.stopId &&
            Number.isFinite(stop.latitude as any) &&
            Number.isFinite(stop.longitude as any),
        );
}
